module.exports = __webpack_public_path__ + "img/attach.fcd4e0a8.svg";